<ng-template #rail>
    <adaa-period-rail
        [steps]="steps()"
        [selectedId]="selectedStepId()"
        [activeYear]="selectedYear()"
        [yearsSelectable]="!dontShowYears()"
        [yearIssues]="yearIssues()"
        (stepSelect)="periodChanged($event)"
        (yearSelect)="periodChanged($event)"
    />
</ng-template>

<div class="row">
    <div class="col-12">
        <div class="bg-card rounded period-slider">
            @if (!isReady()) {
                <div class="w-100 d-flex justify-content-center py-2">
                    <div class="zsk__loader zsk__loader--sm"></div>
                </div>
            } @else if (steps().length > 0) {
                @if (isMobile) {
                    <adaa-item-slider [hasTitle]="false">
                        <div class="period-slider__scroll">
                            <ng-container *ngTemplateOutlet="rail" />
                        </div>
                    </adaa-item-slider>
                } @else {
                    <ng-container *ngTemplateOutlet="rail" />
                }
            }
        </div>
    </div>
</div>
